<script>
import { createHelpers } from "vuex-map-fields";
import { IconNewTab } from '@/icons'

const { mapFields } = createHelpers({
  getterType: 'marketplace/getField',
  mutationType: 'marketplace/updateField',
});

export default {
  name: 'Profile',

  data() {
    return {
      model: 0,
    }
  },

  props: {
    messageAllowed: {
      type: Boolean,
      required: true
    },

    profile: {
      type: Object,
      required: true
    }
  },

  components: {
    IconNewTab,
  },

  computed: {
    ...mapFields([
      'selectedProfile',
      'showCreateProfileDialog',
      'showMessageDialog',
    ]),
  },

  methods: {
    showMessageDialogHandler(profile) {
      this.selectedProfile = profile
      this.showMessageDialog = true
    }
  },
}
</script>

<template>
  <v-col cols="3" class="marketplace-profile m-t-4">
    <div class="profile-card sm">
      <v-carousel v-if="profile.coco_profile_images && profile.coco_profile_images.length > 0" v-model="model" height="auto" style="background: rgba(244, 244, 244, 1);" :class="{ 'single-image' : profile.coco_profile_images.length === 1 }">
        <v-carousel-item v-for="image in profile.coco_profile_images" :key="image.id" style="background-color: rgba(233, 233, 233, 1);">
          <v-img width="290" height="224" aspect-ratio="4/3" contain :src="image.image_url"></v-img>
        </v-carousel-item>
      </v-carousel>
      <div v-else style="width: 100%; height: 224px; background-color: rgba(233, 233, 233, 1); border-radius: 8px 8px 0 0;"></div>
      <div class="profile-details">
        <div class="profile-details__top">
          <h4 class="d-flex">
            <span>{{ profile.brand_name }}</span>
            <a
              v-if="(profile.coco_social_media && profile.coco_social_media[0] && profile.coco_social_media[0].url !== '') || profile.social_media"
              :href="(profile.coco_social_media && profile.coco_social_media[0]) ? profile.coco_social_media[0].url : profile.social_media"
              target="_blank"
              class="instagram-link">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.00014 3.89989C7.18923 3.89989 6.39654 4.14035 5.7223 4.59087C5.04806 5.04138 4.52255 5.68171 4.21223 6.43089C3.90191 7.18007 3.82072 8.00444 3.97892 8.79976C4.13712 9.59509 4.5276 10.3256 5.101 10.899C5.67439 11.4724 6.40494 11.8629 7.20027 12.0211C7.99559 12.1793 8.81996 12.0981 9.56914 11.7878C10.3183 11.4775 10.9586 10.952 11.4092 10.2777C11.8597 9.60349 12.1001 8.8108 12.1001 7.99989C12.1015 7.4611 11.9963 6.92736 11.7907 6.42933C11.5852 5.9313 11.2832 5.4788 10.9022 5.09781C10.5212 4.71683 10.0687 4.41488 9.5707 4.2093C9.07267 4.00372 8.53893 3.89857 8.00014 3.89989ZM8.00014 10.6699C7.47206 10.6699 6.95584 10.5133 6.51676 10.2199C6.07768 9.92653 5.73546 9.50954 5.53338 9.02166C5.33129 8.53378 5.27842 7.99693 5.38144 7.479C5.48446 6.96107 5.73876 6.48532 6.11216 6.11192C6.48557 5.73851 6.96132 5.48422 7.47925 5.3812C7.99717 5.27817 8.53402 5.33105 9.0219 5.53313C9.50978 5.73522 9.92678 6.07744 10.2202 6.51652C10.5135 6.9556 10.6701 7.47182 10.6701 7.99989C10.6701 8.70802 10.3888 9.38715 9.88811 9.88787C9.38739 10.3886 8.70827 10.6699 8.00014 10.6699ZM13.2301 3.72989C13.2301 3.92767 13.1715 4.12101 13.0616 4.28546C12.9517 4.44991 12.7955 4.57808 12.6128 4.65377C12.4301 4.72946 12.229 4.74926 12.035 4.71068C11.8411 4.67209 11.6629 4.57685 11.523 4.437C11.3832 4.29715 11.2879 4.11896 11.2494 3.92498C11.2108 3.731 11.2306 3.52994 11.3063 3.34721C11.3819 3.16448 11.5101 3.0083 11.6746 2.89842C11.839 2.78854 12.0324 2.72989 12.2301 2.72989C12.4954 2.72989 12.7497 2.83525 12.9372 3.02279C13.1248 3.21032 13.2301 3.46468 13.2301 3.72989ZM15.9401 4.72989C15.9692 3.48672 15.5055 2.28249 14.6501 1.37989C13.7524 0.51358 12.5476 0.0388495 11.3001 0.0598926C10.0001 -0.000107422 6.00014 -0.000107422 4.70014 0.0598926C3.45734 0.0329817 2.25391 0.496394 1.35014 1.34989C0.49477 2.25249 0.0310507 3.45672 0.0601367 4.69989C0.000136718 5.99989 0.000136718 9.99989 0.0601367 11.2999C0.0310507 12.5431 0.49477 13.7473 1.35014 14.6499C2.25391 15.5034 3.45734 15.9668 4.70014 15.9399C6.02014 16.0199 9.98014 16.0199 11.3001 15.9399C12.5433 15.969 13.7475 15.5053 14.6501 14.6499C15.5055 13.7473 15.9692 12.5431 15.9401 11.2999C16.0001 9.99989 16.0001 5.99989 15.9401 4.69989V4.72989ZM14.2401 12.7299C14.1044 13.0738 13.8994 13.3862 13.6379 13.6477C13.3765 13.9091 13.0641 14.1141 12.7201 14.2499C11.1677 14.5637 9.5807 14.6713 8.00014 14.5699C6.42289 14.6715 4.83914 14.5639 3.29014 14.2499C2.9462 14.1141 2.63381 13.9091 2.37235 13.6477C2.11088 13.3862 1.90591 13.0738 1.77014 12.7299C1.35014 11.6699 1.44014 9.16989 1.44014 8.00989C1.44014 6.84989 1.35014 4.33989 1.77014 3.28989C1.90208 2.94256 2.10559 2.62685 2.36745 2.36327C2.62931 2.09968 2.94368 1.89411 3.29014 1.75989C4.83914 1.44587 6.42289 1.33827 8.00014 1.43989C9.5807 1.33844 11.1677 1.44604 12.7201 1.75989C13.0641 1.89567 13.3765 2.10064 13.6379 2.3621C13.8994 2.62357 14.1044 2.93595 14.2401 3.27989C14.6601 4.33989 14.5601 6.83989 14.5601 7.99989C14.5601 9.15989 14.6601 11.6699 14.2401 12.7199V12.7299Z" fill="#0E3B4D"/>
              </svg>
            </a>
          </h4>
        </div>
        <div class="profile-details__bottom">
          <p class="country">
            {{ (profile.location && profile.location.country) ? profile.location.country : profile.location }}
          </p>
          <p class="published-products">
            {{ profile.num_of_products }} published products
          </p>
          <p v-if="profile.website" class="website">
            <a :href="profile.website" class="link link-underline" target="_blank">
              Website
              <IconNewTab />
            </a>
          </p>
          <v-btn v-if="messageAllowed" elevation="0" class="btn btn-border inverse lg btn-message" @click="showMessageDialogHandler(profile)">Message</v-btn>
          <v-btn v-else elevation="0" class="btn btn-border inverse lg btn-message" @click="showCreateProfileDialog = true">Message</v-btn>
        </div>
      </div>
    </div>
  </v-col>
</template>

<style lang="scss" scoped>
.btn-message {
  font-size: 14px !important;
  height: 38px !important;
  margin-top: 4px;
  width: 98px;
}

h4 {
  font-size: 16px;
  font-weight: normal;

  > span {
    margin-right: 10px;
    word-break: break-all;
  }
}

.instagram-link {
  display: inline-block;
  transform: translateY(3px);
}

.marketplace-profile {
  border-radius: 8px;
  position: relative;
}

.country {
  color: #767676;
}

.profile-details {
  padding-bottom: 15px !important;
}
</style>
